import type { User } from '@/types/user'

/**
 * MH9-13: quem ve o Assistente IA. Admin sempre (testa antes de liberar); padrinho so com a
 * flag que o admin liga em /admin/assistente-ia. Espelho de `User#assistant_access?` (API) —
 * a API recusa com 403 `assistant_disabled` quem nao passa aqui.
 */
export function hasAssistantAccess(user: Pick<User, 'role' | 'assistant_enabled'> | null | undefined): boolean {
  if (!user) return false
  if (user.role === 'admin') return true
  return user.role === 'instructor' && user.assistant_enabled === true
}
